import { Link } from 'react-router-dom';
import { publicRoutes } from '@config/routes';

export function RegisterPage() {
  return (
    <div className="font-sans text-slate-600 h-screen w-full relative overflow-hidden flex items-center justify-center selection:bg-primary-soft selection:text-primary">
      {/* Animated background blobs */}
      <div className="fixed top-0 left-0 w-full h-full overflow-hidden -z-10">
        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-indigo-100/60 rounded-full blur-[100px] animate-blob mix-blend-multiply opacity-70"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-purple-100/60 rounded-full blur-[100px] animate-blob mix-blend-multiply opacity-70" style={{ animationDelay: '2s' }}></div>
        <div className="absolute top-[30%] right-[20%] w-[40%] h-[40%] bg-blue-100/60 rounded-full blur-[100px] animate-blob mix-blend-multiply opacity-70" style={{ animationDelay: '4s' }}></div>
      </div>

      <div className="w-full px-6 flex justify-center z-10">
        <div className="glass-card w-full max-w-[480px] p-8 md:p-12 rounded-4xl shadow-soft flex flex-col items-center transform transition-all hover:scale-[1.005] duration-500">
          {/* Logo */}
          <div className="flex flex-col items-center mb-10 text-center">
            <div className="w-14 h-14 bg-gradient-to-br from-primary to-secondary rounded-2xl flex items-center justify-center text-white shadow-glow mb-4 transform rotate-3 hover:rotate-6 transition-transform duration-300">
              <span className="material-symbols-outlined text-[28px]">spa</span>
            </div>
            <h1 className="text-2xl font-bold text-slate-900 tracking-tight mb-1">HRM SaaS</h1>
            <p className="text-[11px] font-bold text-slate-400 uppercase tracking-[0.2em]">Employee Happiness Platform</p>
          </div>

          {/* Content */}
          <div className="w-full mb-8 text-center">
            <h2 className="text-3xl font-extrabold text-slate-800 mb-2">Register</h2>
            <p className="text-slate-500 font-medium">Registration page will be implemented soon.</p>
          </div>

          {/* Back Link */}
          <div className="mt-8 pt-2 w-full flex justify-center">
            <Link
              to={publicRoutes.login}
              className="flex items-center gap-2 text-sm font-bold text-slate-500 hover:text-slate-800 transition-colors group px-4 py-2 rounded-xl hover:bg-slate-50"
            >
              <span className="material-symbols-outlined text-[18px] group-hover:-translate-x-1 transition-transform">
                arrow_back
              </span>
              Back to Sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

